<template>
    <v-row class="pa-2">
        <v-col cols="3">    
            <v-skeleton-loader
                type="table-cell, divider, table-cell, divider, table-cell"
            ></v-skeleton-loader>
        </v-col>
        <v-col>    
            <v-skeleton-loader
                type="table-cell,divider,table-cell, divider, table-cell"
            ></v-skeleton-loader>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "WarehouseLoader"
}
</script>

<style>

</style>